import { useEffect, useState } from 'react';
import { DropPointDTO } from '../../api/api';
import Select, { MenuItem } from '../select/Select';
import { FormControl } from '@mui/material';
import WarehouseService from '../../services/WarehouseService';

interface Props {
  warehouseId?: string;
  onChange: (dropPoint: DropPointDTO) => void;
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  error?: boolean;
}

const DropPointsDropdown = (props: Props) => {
  const { disabled, fullWidth, label, error, warehouseId: value, onChange } = props;
  const [dropPoints, setDropPoints] = useState<DropPointDTO[]>([]);

  useEffect(() => {
    WarehouseService.getAllDropPoints().then((res) => {
      const sortedDropPoints = res.sort((a, b) =>
        (a.name ?? '').toLowerCase().localeCompare((b.name ?? '').toLocaleLowerCase())
      );
      setDropPoints(sortedDropPoints);
    });
  }, []);

  const handleSelectDropPoint = (warehouseId: string) => {
    const dropPoint = dropPoints.find((d) => d.warehouseId === warehouseId);
    dropPoint && onChange(dropPoint);
  };

  return (
    <FormControl fullWidth>
      <Select
        disabled={disabled}
        fullWidth={fullWidth}
        error={error}
        value={value || ''}
        label={label}
        onChange={(e) => handleSelectDropPoint(e.target.value as any)}
      >
        {dropPoints.map((d) => (
          <MenuItem key={d.warehouseId} value={d.warehouseId}>
            {d.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropPointsDropdown;
